import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { HomeService } from "../../../services";
import { useDispatch } from "react-redux";
import { alertActions } from "../../../actions";
import { useSelector } from "react-redux";
import { StandardService } from "../../../services";
import { MyAccountService } from "../../../services";
import { BookingDetailsService } from "../../../services/BookingDetailsService";

const useHome = (location, t) => {
  const [roomList, setRoomList] = useState([]);
  const [notAvailable, setNotAvailable] = useState([]);
  const [initialRoom, setInitialRoom] = useState(false);
  const [selectedRoomCount, setSelectedRoomCount] = useState("");
  const [selectedAdultCount, setSelectedAdultCount] = useState("");
  const [selectedChildrenCount, setSelectedChildrenCount] = useState("");
  const [loader, setLoader] = useState("notset");
  const [singleRoomDetail, setSingleRoomDetail] = useState("");
  const user_id = useSelector((state) => state?.userData?.user?._id);
  const user_name = useSelector((state) => state?.userData?.user?.name);
  const user_email = useSelector((state) => state?.userData?.user?.email);
  const user_phone = useSelector((state) => state?.userData?.user?.phone);
  const [removeRooms, setRemoveRooms] = useState(false);
  const [adultcount, setAdultcount] = useState("");
  const [roomsDatassss, setRoomsDatassss] = useState([]);
  const [addedPersons, setAddedPersons] = useState(0);
  const [cartData, setCartData] = useState("");
  const [cartId, setCartId] = useState("");
  const [differenceDate, setDifferenceDate] = useState("");
  const [childAgeSelected, setChildAgeSelected] = useState(false);
  const [childrenCount, setChildrenCount] = useState("");
  const [childrenAges, setChildrenAges] = useState([]);
  const [modalRenderTrigger, setModalRenderTrigger] = useState(false);
  const [updateClicked, setUpdateClicked] = useState(false);
  const AdultCountLoc = localStorage.getItem("AdultCount");
  const RoomCountLoc = localStorage.getItem("RoomCount");
  const ChildrenCountLoc = localStorage.getItem("ChildrenCount");
  const [extractedData, setExtractedData] = useState([]);
  const [editIndex, setEditIndex] = useState();
  const [tempAdultCount, setTempAdultCount] = useState();
  const [tempRoomCount, setTempRoomCount] = useState();
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [dateSelection, setDateSelection] = useState(true);
  const [selectAdultEdit, setSelectAdultEdit] = useState(0);
  const [childArrayAge, setChildAgeArray] = useState([]);
  const [refreshClickked, setRefreshClicked] = useState(false);
  const [nutralCheckIn, setNutralChein] = useState(
    localStorage.getItem("datetime1")
  );
  const [nutralCheckOut, setNutralCheOut] = useState(
    localStorage.getItem("datetime2")
  );
  const [datetimeIn, setdatetimeIn] = useState(
    localStorage.getItem("datetimeIn")
  );
  const [datetimeOut, setdatetimeOut] = useState(
    localStorage.getItem("datetimeOut")
  );
  const [selectChildrenEdit, setSelectChildrenEdit] = useState(0);
  const [adultLengthDisplay, setAdultLengthDisplay] = useState(0);
  const [childrenLengthDisplay, setChildrenLengthDisplay] = useState(0);

  console.log("roomsssssssss", roomsDatassss);
  console.log("tempRoomCount", tempRoomCount);
  console.log("tempAdultCount", tempAdultCount);
  console.log(
    "datetimeIn",
    new Date(new Date(datetimeIn).setDate(new Date(datetimeIn).getDate() + 1))
      .toISOString()
      .split("T")[0]
  );
  console.log(
    "datetimeOut",
    new Date(new Date(datetimeOut).setDate(new Date(datetimeOut).getDate() + 1))
      .toISOString()
      .split("T")[0]
  );

  useEffect(() => {
    console.log("jhasgdjsgjfgjds");
    setChildrenAges([]);
  }, [childArrayAge]);

  const AddRoomCart = async (data) => {
    setAdultLengthDisplay(0);
    setChildrenLengthDisplay(0);
    try {
      setLoader("loading");
      const response = await HomeService.checkRoom(
        RoomCountLoc,
        AdultCountLoc,
        ChildrenCountLoc,
        false,
        childArrayAge ? childArrayAge : []
      );
      if (response.data.status.code == 0) {
        // navigate(`/cart-page`);

        setAdultcount(1);
        setUpdateClicked(false);
        if (user_id) {
          console.log(data, cartData, "addRoom");

          // Extract Room Type IDs
          const extractedIds = cartData?.rooms
            .filter(
              (_, index) =>
                index %
                  calculateDifference(
                    cartData?.arrival_date,
                    cartData?.departure_date
                  ) ===
                0
            )
            .map((item) => item.roomTypeId);

          console.log("Extracted Room Type IDs:", extractedIds);
          if (extractedIds?.length > 0) {
            let currentCount =
              extractedIds.filter((id) => id === data._id).length || 0;

            console.log(
              `Available rooms for ${data._id}:`,
              data.available_rooms
            );
            console.log(`Current count for ${data._id}:`, currentCount);

            if (currentCount < data.available_rooms) {
              setRemoveRooms(true);
              // console.log(`Allowed: ${data._id}`);
            } else {
              dispatch(
                alertActions.error(
                  `You've reached the limit of ${data.available_rooms} rooms. Please select a different room type.`
                )
              );
              // console.log(`Not Allowed: ${data._id}`);
            }
          } else {
            setRemoveRooms(true);
          }
          setSingleRoomDetail(data);
        } else {
          dispatch(alertActions.success("Please login to continue"));
          navigate("/login");
        }
      } else {
        dispatch(alertActions.error(response.data.status.message));
      }
    } catch (error) {
      dispatch(alertActions.error(t(error)));
      console.log("error", error);
    } finally {
      setLoader("isFull");
    }
  };

  const updateRoom = () => {
    console.log(
      extractedData,
      "indexData",
      editIndex,
      differenceDate,
      "extractedData",
      adultcount,
      childrenCount,
      childrenAges
    );
    console.log("dgahdgfjdgsfjhg", childrenCount, childrenAges);
    if (childrenCount == childrenAges?.length || childrenCount == 0) {
      setChildAgeSelected(false);
      setExtractedData((prevData) => {
        console.log(prevData, "prevData");
        const updatedData = prevData.map((item, index) => {
          if (
            index >= editIndex * differenceDate &&
            index < (editIndex + 1) * differenceDate
          ) {
            // Update only the selected index range
            return {
              ...item,
              adultcount: item.actualAdultCount,
              childrenAges: childrenAges,
              adults: adultcount,
              infants: childrenAges,
            };
          } else {
            // Update all other items
            return {
              ...item,
              adults: Number(item.actualAdultCount),
            };
          }
        });
        console.log("After update:", updatedData); // Log updated extractedData
        BookingDetailsService.updateCartRooms(updatedData)
          .then((res) => {
            if (res?.data?.status?.code === 0) {
              setRemoveRooms(false);
              setLoader("isfull");
              MyAccountService.getCartItems(user_id, 1)
                .then((res) => {
                  if (res?.data?.status?.code === 0) {
                    setCartData(res?.data?.data[0]);
                    setCartId(res?.data?.data[0]?.cartId);
                    console.log(res?.data?.data[0]);
                    setDifferenceDate(
                      calculateDifference(
                        res?.data?.data[0]?.arrival_date,
                        res?.data?.data[0]?.departure_date
                      )
                    );
                    console.log(
                      calculateDifference(
                        res?.data?.data[0]?.arrival_date,
                        res?.data?.data[0]?.departure_date
                      ),
                      "DifferenceDates"
                    );

                    setRoomsDatassss(res?.data?.data[0]?.rooms);
                    setTempRoomCount((prev) => prev - 1);
                    setTempAdultCount((prev) => prev - adultcount);
                    setSelectedChildrenCount((prev) => prev - childrenCount);

                    // setPageCount(res?.data?.data?.totalPages);
                    // // console.log(res?.data?.data?.docs, "jdkshgsdfhg");
                    // const totalGST = res?.data?.data?.reduce((sum, item) => {
                    //   return sum + (item.gst || 0);
                    // }, 0);
                    // const totalRoomCharge = res?.data?.data?.reduce((sum, item) => {
                    //   return sum + (item.roomCharge || 0);
                    // }, 0);
                    // setTotalingGst(totalGST);
                    // setTotalingRoomCharge(totalRoomCharge);
                    // setCartData(res?.data);
                    setLoader("isfull");
                  }
                })
                .catch((error) => {
                  setLoader("isfull");
                  console.log("Errorreg", error);
                  dispatch(alertActions.error(error));
                });
              dispatch(alertActions.success(res.data.status.message));
            } else {
              setLoader("isempty");
              dispatch(alertActions.error(res.data.status.message));
            }
          })
          .catch((error) => {
            console.log("Errorreg", error);
          });
        return updatedData;
      });
    } else {
      setChildAgeSelected(true);
    }
  };

  const closeModal = () => {
    setRemoveRooms(false);
  };

  // const closeModalEdit = (selectAdultEdit) => {
  //   setRemoveRooms(false);
  //   setTempRoomCount((prev) => prev - 1);
  //   setTempAdultCount((prev) => prev - selectAdultEdit);
  //   setSelectAdultEdit(0);
  // };

  const closeModalEdit = (selectAdultEdit, selectChildrenEdit) => {
    setRemoveRooms(false);
    setTempRoomCount((prev) => prev - 1);
    setTempAdultCount((prev) => prev - selectAdultEdit);
    setSelectedChildrenCount((prev) => prev - selectChildrenEdit);
    setChildrenCount((prev) => prev - selectChildrenEdit);
    setSelectAdultEdit(0);
    setSelectChildrenEdit(0);
  };

  const handleChangeAdult = (e) => {
    setAdultcount(e.target.value);
    console.log("adult chaange", e.target.value);
  };

  // useEffect(() => {
  //   setSelectedAdultCount(selectedAdultCount - adultcount);
  //   setSelectedRoomCount(selectedRoomCount - 1);
  //   // setAdultcount()
  // }, [adultcount]);

  const handleChange = (e) => {
    setChildrenAges([]);
    setChildrenCount(parseInt(e.target.value, 10)); // Convert to number
    setModalRenderTrigger((prev) => !prev);
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();
  var dataPath = "";
  localStorage.removeItem("service");
  localStorage.removeItem("service1");
  localStorage.removeItem("adult");
  localStorage.removeItem("amountdata1");
  localStorage.removeItem("id");
  localStorage.removeItem("rooms");
  localStorage.removeItem("children");
  localStorage.removeItem("amountdata");

  localStorage.removeItem("rzp_device_id");
  useEffect(() => {
    // localStorage.removeItem("datetime1");
    // localStorage.removeItem("datetime2");
    // localStorage.setItem("datetime1", localStorage.getItem("datetimes"));
    // localStorage.setItem("datetime2", localStorage.getItem("datetimes1"));
    localStorage.removeItem("datetimes");
    localStorage.removeItem("datetimes1");
    // localStorage.removeItem("RoomCount");
    // localStorage.removeItem("AdultCount");
    // localStorage.removeItem("ChildrenCount");
    // localStorage.removeItem("ChildrenAges");
    // localStorage.removeItem("ChildrenAgesArray");
    setSelectedAdultCount(localStorage.getItem("AdultCount"));
    setSelectedRoomCount(localStorage.getItem("RoomCount"));
    setChildrenCount(localStorage.getItem("ChildrenCount"));
    setChildrenAges(localStorage.getItem("ChildrenAges"));
    setChildAgeArray(localStorage.getItem("ChildrenAgesArray"));
    if (user_id) {
      //Remove local storage when user logsin after entering data
      //     localStorage.removeItem("RoomCount");
      // localStorage.removeItem("AdultCount");
      // localStorage.removeItem("ChildrenCount");
      // localStorage.removeItem("ChildrenAges");
      // localStorage.removeItem("ChildrenAgesArray");
      MyAccountService.getCartItems(user_id, 1)
        .then((res) => {
          if (res?.data?.status?.code === 0) {
            setCartData(res?.data?.data[0]);
            setCartId(res?.data?.data[0]?.cartId);
            // setStartTime(res?.data?.data[0]?.arrival_date)
            // setEndTime(res?.data?.data[0]?.departure_date)
            setTempAdultCount(0);
            setTempRoomCount(0);
            setSelectedChildrenCount(0);
            console.log(res?.data?.data[0]);
            setDifferenceDate(
              calculateDifference(
                res?.data?.data[0]?.arrival_date,
                res?.data?.data[0]?.departure_date
              )
            );
            console.log(
              calculateDifference(
                res?.data?.data[0]?.arrival_date,
                res?.data?.data[0]?.departure_date
              ),
              "DifferenceDates"
            );
            if (
              startTime == res?.data?.data[0]?.arrival_date &&
              endTime == res?.data?.data[0]?.departure_date
            ) {
              setRoomsDatassss(res?.data?.data[0]?.rooms);
            }

            setLoader("isfull");
          }
        })
        .catch((error) => {
          setLoader("isfull");
          console.log("Errorreg", error);
          dispatch(alertActions.error(error));
        });
    }
  }, []);

  // Periodically check `localStorage` for changes
  useEffect(() => {
    const intervalId = setInterval(() => {
      // Check if `localStorage` values have changed
      const updatedDatetime1 = localStorage.getItem("datetime1");
      const updatedDatetime2 = localStorage.getItem("datetime2");

      // If values have changed, update the state
      if (updatedDatetime1 !== nutralCheckIn) {
        setNutralChein(updatedDatetime1);
      }
      if (updatedDatetime2 !== nutralCheckOut) {
        setNutralCheOut(updatedDatetime2);
      }
    }, 1000); // Check every second (adjust as needed)

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, [nutralCheckIn, nutralCheckOut]); // Ensure we track changes to these values

  useEffect(() => {
    console.log("EnteredInside11");

    const handleBeforeUnload = () => {
      console.log("EnteredInside22");
      localStorage.removeItem("datetimes1");
      localStorage.removeItem("RoomCount");
      localStorage.removeItem("AdultCount");
      localStorage.removeItem("ChildrenCount");
      localStorage.removeItem("ChildrenAges");
      localStorage.removeItem("ChildrenAgesArray");
      localStorage.removeItem("datetime1");
      localStorage.removeItem("datetime2");
      localStorage.removeItem("ChildrenAgesArray");
      localStorage.removeItem("datetimeIn");
      localStorage.removeItem("datetimeOut");

      setTempAdultCount(0);
      setTempRoomCount(0);
      setStartTime("");
      setEndTime("");
      setRefreshClicked(true);
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    // Cleanup the event listener when component unmounts
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const convertDateFormat = (dateString) => {
    if (!dateString) return "N/A"; // Handle missing data

    const dateParts = dateString.split(" "); // Split the string into parts
    if (dateParts.length < 5) return "Invalid Date"; // Ensure format is correct

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = dateParts[2];
    const month = (monthNames.indexOf(dateParts[1]) + 1)
      .toString()
      .padStart(2, "0"); // Convert month to number
    const year = dateParts[3];

    return `${year}-${month}-${day}`;
  };

  const extractAndAddOneDay = (dateTimeString) => {
    if (!dateTimeString) return "N/A"; // Handle missing data

    const datePart = dateTimeString.split("T")[0]; // Extract date
    const date = new Date(datePart);
    if (isNaN(date.getTime())) return "Invalid Date"; // Handle invalid dates

    if (dateSelection) {
      date.setDate(date.getDate() + 1);
      setDateSelection(false);
    } // Add one day
    return date.toISOString().split("T")[0]; // Return updated date in YYYY-MM-DD format
  };

  // const convertISOToDate = (isoString) => {
  //   const date = new Date(isoString);
  //   return date?.toISOString()?.split("T")[0]; // Extracts YYYY-MM-DD
  // };
  /**
   * get room list
   */
  useEffect(() => {
    console.log(
      cartData,
      "gdhasgdhsagdhg",
      localStorage.getItem("datetime1"),
      localStorage.getItem("datetime2")
    );
    // setNutralChein(localStorage.getItem("datetime1"))
    // setNutralCheOut(localStorage.getItem("datetime2"))
    if (
      localStorage?.getItem("datetime1") !== null &&
      localStorage?.getItem("datetime2") !== null
    ) {
      setStartTime(convertDateFormat(localStorage?.getItem("datetime1")));
      // const dateTimeString = localStorage?.getItem("datetime2");

      // if (dateTimeString) {
      //   if (dateTimeString.includes("T")) {
      //     // ISO 8601 format: Call extractAndAddOneDay
      //     setEndTime(extractAndAddOneDay(dateTimeString));
      //   } else {
      //     // Non-ISO format: Call convertDateFormat
      //     setEndTime(convertDateFormat(dateTimeString));
      //   }
      // }
      setEndTime(convertDateFormat(localStorage?.getItem("datetime2")));
    }
    setSelectedRoomCount(localStorage.getItem("RoomCount"));
    setSelectedAdultCount(localStorage.getItem("AdultCount"));
    setSelectedChildrenCount(localStorage.getItem("ChildrenCount"));
    setChildAgeArray(localStorage.getItem("ChildrenAgesArray"));
    setChildrenAges(
      localStorage.getItem("ChildrenAges")?.split(",").map(Number)
    );
    console.log(localStorage.getItem("ChildrenAges"));

    setChildrenCount(
      localStorage.getItem("ChildrenCount") < 2
        ? localStorage.getItem("ChildrenCount")
        : 2
    );
    if (user_id) {
      MyAccountService.getCartItems(user_id, 1)
        .then((res) => {
          if (res?.data?.status?.code === 0) {
            setCartData(res?.data?.data[0]);
            setCartId(res?.data?.data[0]?.cartId);
            console.log(res?.data?.data[0], "EnetredCartDataaaa");
            setChildrenCount(0);
            setChildrenAges(0);
            setDifferenceDate(
              calculateDifference(
                res?.data?.data[0]?.arrival_date,
                res?.data?.data[0]?.departure_date
              )
            );
            console.log(
              calculateDifference(
                res?.data?.data[0]?.arrival_date,
                res?.data?.data[0]?.departure_date
              ),
              "DifferenceDates"
            );
            if (
              startTime == res?.data?.data[0]?.arrival_date &&
              endTime == res?.data?.data[0]?.departure_date
            ) {
              setRoomsDatassss(res?.data?.data[0]?.rooms);
            }
            // setPageCount(res?.data?.data?.totalPages);
            // // console.log(res?.data?.data?.docs, "jdkshgsdfhg");
            // const totalGST = res?.data?.data?.reduce((sum, item) => {
            //   return sum + (item.gst || 0);
            // }, 0);
            // const totalRoomCharge = res?.data?.data?.reduce((sum, item) => {
            //   return sum + (item.roomCharge || 0);
            // }, 0);
            // setTotalingGst(totalGST);
            // setTotalingRoomCharge(totalRoomCharge);
            // setCartData(res?.data);
            setLoader("isfull");
          }
        })
        .catch((error) => {
          setLoader("isfull");
          console.log("Errorreg", error);
          dispatch(alertActions.error(error));
        });
    }
    console.log(localStorage.getItem("RoomCount") > 1);
    if (
      new Date(location?.state?.checkindate) >=
        new Date(location?.state?.checkoutdate) &&
      !selectedAdultCount &&
      !selectedRoomCount
    ) {
      dispatch(alertActions.error(t("Checkin_and_Checkout_Date_is_Invalid")));
      HomeService.roomlist()
        .then((res) => {
          if (res?.data?.status?.code === 0) {
            setRoomList(res?.data?.data?.rooms);
            setLoader("isfull");
            setInitialRoom(true);
            localStorage.setItem("datetimes", null);
            localStorage.setItem("datetimes1", null);
            dispatch(
              alertActions.error(t("Checkin_and_Checkout_Date_is_Invalid"))
            );
          }
        })
        .catch((error) => {
          console.log("Errorreg", error);
        });
    } else if (
      location?.state?.checkindate === undefined ||
      (location?.state?.checkoutdate === undefined &&
        !selectedAdultCount &&
        !selectedRoomCount)
    ) {
      HomeService.roomlist()
        .then((res) => {
          if (res?.data?.status?.code === 0) {
            setRoomList(res?.data?.data?.rooms);
            setLoader("isfull");
            setInitialRoom(true);
            localStorage.setItem("datetimes", null);
            localStorage.setItem("datetimes1", null);
          }
        })
        .catch((error) => {
          console.log("Errorreg", error);
        });
    } else if (!selectedAdultCount && !selectedRoomCount) {
      HomeService.roomlist()
        .then((res) => {
          if (res?.data?.status?.code === 0) {
            setRoomList(res?.data?.data?.rooms);
            setLoader("isfull");
            setInitialRoom(true);
            localStorage.setItem("datetimes", null);
            localStorage.setItem("datetimes1", null);
          }
        })
        .catch((error) => {
          console.log("Errorreg", error);
        });
    } else {
      if (location?.state?.id) {
        setLoader("loading");
        console.log("one time", childArrayAge);
        HomeService.getRoomList(
          datetimeIn
            ? new Date(
                new Date(datetimeIn).setDate(new Date(datetimeIn).getDate() + 1)
              )
                .toISOString()
                .split("T")[0]
            : location?.state?.checkindate,
          datetimeOut
            ? new Date(
                new Date(datetimeOut).setDate(
                  new Date(datetimeOut).getDate() + 1
                )
              )
                .toISOString()
                .split("T")[0]
            : location?.state?.checkoutdate,
          selectedAdultCount,
          selectedRoomCount,
          localStorage.getItem("ChildrenAgesArray") || ""
          // childArrayAge ? childArrayAge : []
        )
          .then((res) => {
            if (res?.data?.status?.code === 0) {
              setInitialRoom(false);
              console.log(res, "hfgsdjhsdgf");
              setRoomList(res?.data?.data[0]?.roomTypeDetails);
              setNotAvailable(res?.data?.data[0]?.nonAvailableRooms);
              setLoader("isfull");
              if (res?.data?.status?.message !== "rooms-list") {
                return;
                dispatch(alertActions.success(res?.data?.status?.message));
              }
            } else {
              setRoomList("");
            }
          })
          .catch((error) => {
            setRoomList("");
            console.log("Errorreg", error);
          });
      } else {
        setLoader("loading");
        console.log("two time", childArrayAge);
        HomeService.getRoomList(
          datetimeIn
            ? new Date(
                new Date(datetimeIn).setDate(new Date(datetimeIn).getDate() + 1)
              )
                .toISOString()
                .split("T")[0]
            : location?.state?.checkindate,
          datetimeOut
            ? new Date(
                new Date(datetimeOut).setDate(
                  new Date(datetimeOut).getDate() + 1
                )
              )
                .toISOString()
                .split("T")[0]
            : location?.state?.checkoutdate,
          selectedAdultCount,
          selectedRoomCount,
          localStorage.getItem("ChildrenAgesArray") || ""
          // childArrayAge ? childArrayAge : []
        )
          .then((res) => {
            if (res?.data?.status?.code === 0) {
              console.log(res, "hfgsdjhsdgf");
              setInitialRoom(false);
              setRoomList(res?.data?.data[0]?.roomTypeDetails);
              setNotAvailable(res?.data?.data[0]?.nonAvailableRooms);
              setLoader("isfull");
              if (res?.data?.status?.message !== "rooms-list") {
                dispatch(alertActions.success(res?.data?.status?.message));
              }
            } else {
              setRoomList("");
            }
          })
          .catch((error) => {
            setRoomList("");
            console.log("Errorreg", error);
          });
      }
    }
  }, [
    location?.state?.id,
    location,
    startTime,
    selectedAdultCount,
    selectedRoomCount,
  ]);

  // useEffect(() => {
  //   setChildAgeArray(localStorage.getItem("ChildrenAgesArray"));
  // }, [childArrayAge]);

  useEffect(() => {
    HomeService.roomlist()
      .then((res) => {
        if (res?.data?.status?.code === 0) {
          setRoomList(res?.data?.data?.rooms);
          setLoader("isfull");
          setInitialRoom(true);
          localStorage.setItem("datetimes", null);
          localStorage.setItem("datetimes1", null);
        }
      })
      .catch((error) => {
        console.log("Errorreg", error);
      });
    if (cartData) {
      const bookingIds = cartData?.rooms.map((item) => item.bookingId);
      console.log(bookingIds, "cartData", cartData?.cartId);
      MyAccountService.deleteCartBooking(bookingIds, cartData?.cartId)
        .then((res) => {
          if (res?.data?.status?.code === 0) {
            // setPageCount(res?.data?.data?.totalPages);
            setRemoveRooms(false);
            setCartData("");
            setTempAdultCount(localStorage.getItem("AdultCount"));
            setTempRoomCount(localStorage.getItem("RoomCount"));
            // getBookingHistory();
            // dispatch(alertActions.success(res?.data?.status?.message));
            // setLoader("isfull");
            // window.location.reload();
          } else {
            setLoader("isfull");
            setRemoveRooms(false);
            // dispatch(alertActions.error(res?.data?.status?.message));
          }
        })
        .catch((error) => {
          setLoader("isfull");
          setRemoveRooms(false);
          console.log("Errorreg", error);
        });
    }
  }, [nutralCheckIn, nutralCheckOut]);

  /**
   * navigate
   * @param {*} data
   */
  const selectRoom = (data, roomsavailable) => {
    if (
      new Date(location?.state?.checkindate) >=
      new Date(location?.state?.checkoutdate)
    ) {
      dispatch(alertActions.error(t("Checkin_and_Checkout_Date_is_Invalid")));
    } else {
      if (
        localStorage.getItem("datetimes") &&
        localStorage.getItem("datetimes1")
      ) {
        // localStorage.setItem("datetime1", localStorage.getItem("datetimes"));
        // localStorage.setItem("datetime2", localStorage.getItem("datetimes1"));
        localStorage.removeItem("datetimes");
        localStorage.removeItem("datetimes1");
        localStorage.removeItem("adult");
        localStorage.removeItem("children");
        localStorage.removeItem("rooms");
        localStorage.removeItem("amountdata1");
        localStorage.removeItem("amountdata");
        localStorage.removeItem("service");
        localStorage.removeItem("service1");
        localStorage.removeItem("datetimeIn");
        localStorage.removeItem("datetimeOut");
        navigate(`/standard?id=${data}`, {
          state: {
            id: data,
            loc: location?.state?.loc,
            roomsavailable: roomsavailable,
          },
        });
      } else {
        dispatch(
          alertActions.error(t("Please enter Check-in and Check-out date"))
        );
      }
    }
  };

  const proceedBtn = async (proceed) => {
    try {
      setLoader("loading");
      const response = await HomeService.checkRoom(
        RoomCountLoc,
        AdultCountLoc,
        ChildrenCountLoc,
        proceed,
        childArrayAge ? childArrayAge : []
      );
      if (response.data.status.code == 0) {
        navigate(`/cart-page`);
      } else {
        dispatch(alertActions.error(response.data.status.message));
      }
    } catch (error) {
      dispatch(alertActions.error(t(error)));
      console.log("error", error);
    } finally {
      setLoader("isFull");
    }
  };

  const addRoom = () => {
    // console.log(childrenCount, childrenAges, "fhjasdgfuadsgfuigasdf");
    // setAddedPersons((prevCount) => prevCount - 1);
    // if (childrenAges && adultcount) {
    // console.log(childrenCount, "childrenCount");

    // const actualValues = childrenAges.filter((item) => item !== undefined);
    // Ensure childrenAges is always an array
    // childrenAges = Array.isArray(childrenAges)
    //   ? childrenAges
    //   : childrenAges.split("").map(Number);

    // const actualValues = childrenAges.filter((item) => item !== undefined);
    console.log(childrenAges, "childrenAges");
    //   if(childrenAges !== 0)
    //  {
    const actualValues = (
      Array.isArray(childrenAges)
        ? childrenAges
        : typeof childrenAges === "string"
        ? childrenAges.split("").map(Number)
        : []
    ) // Default to an empty array if it's neither string nor array
      .filter((item) => item !== undefined)
      .slice(0, 2);
    if (childrenCount == actualValues?.length || childrenCount == 0) {
      setChildAgeSelected(false);
      var bookingDetails = [
        {
          adults: Number(adultcount ? adultcount : 1),
          infantAge: childrenCount > 0 ? actualValues : [],
        },
      ];
      StandardService.bookingInCartUpdated(
        datetimeIn
          ? new Date(
              new Date(datetimeIn).setDate(new Date(datetimeIn).getDate() + 1)
            )
              .toISOString()
              .split("T")[0]
          : location?.state?.checkindate,
        datetimeOut
          ? new Date(
              new Date(datetimeOut).setDate(new Date(datetimeOut).getDate() + 1)
            )
              .toISOString()
              .split("T")[0]
          : location?.state?.checkoutdate,
        singleRoomDetail.no_of_occupancy,
        singleRoomDetail.no_of_infants,
        user_name,
        user_email,
        user_phone,
        singleRoomDetail._id,
        1,
        singleRoomDetail.price,
        bookingDetails
      )
        .then((res) => {
          if (res?.data?.status?.code === 0) {
            dataPath = res?.data?.data?.[0]?._id;
            const ids = res?.data?.data?.map((item) => item._id) || [];

            console.log(ids, "ids");
            // setBookingId(ids);
            if (user_id) {
              // console.log(ids);
              StandardService.addToCart(user_id, ids)
                .then((res) => {
                  if (res?.data?.status?.code === 0) {
                    dispatch(alertActions.success(res?.data?.status?.message));
                    if (user_id) {
                      MyAccountService.getCartItems(user_id, 1)
                        .then((res) => {
                          if (res?.data?.status?.code === 0) {
                            setCartData(res?.data?.data[0]);
                            setCartId(res?.data?.data[0]?.cartId);
                            console.log(res?.data?.data[0]);
                            setDifferenceDate(
                              calculateDifference(
                                res?.data?.data[0]?.arrival_date,
                                res?.data?.data[0]?.departure_date
                              )
                            );
                            setChildrenAges(
                              Array.isArray(childrenAges)
                                ? childrenAges.slice(2)
                                : [] // Removes the first two items and keeps the rest
                            );

                            console.log("i am called");
                            console.log("adult count he he", adultcount);
                            setSelectedChildrenCount(
                              (prev) => prev - childrenCount
                            );
                            setChildrenCount(0);
                            setRoomsDatassss(res?.data?.data[0]?.rooms);
                            setTempAdultCount(tempAdultCount - adultcount);
                            setTempRoomCount(tempRoomCount - 1);
                            // setPageCount(res?.data?.data?.totalPages);
                            // // console.log(res?.data?.data?.docs, "jdkshgsdfhg");
                            // const totalGST = res?.data?.data?.reduce((sum, item) => {
                            //   return sum + (item.gst || 0);
                            // }, 0);
                            // const totalRoomCharge = res?.data?.data?.reduce((sum, item) => {
                            //   return sum + (item.roomCharge || 0);
                            // }, 0);
                            // setTotalingGst(totalGST);
                            // setTotalingRoomCharge(totalRoomCharge);
                            // setCartData(res?.data);
                            setLoader("isfull");
                          }
                        })
                        .catch((error) => {
                          setLoader("isfull");
                          console.log("Errorreg", error);
                          dispatch(alertActions.error(error));
                        });
                    }
                    // navigate("/");
                    setRemoveRooms(false);
                    setLoader("isfull");
                  } else {
                    dispatch(alertActions.error(res?.data?.status?.message));
                    // window.location.reload();
                    setRemoveRooms(false);
                    setLoader("isfull");
                  }
                })
                .catch((err) => console.log(err));
              // location?.state?.data.map((data) => mydata.push(data?._id));
              // console.log(mydata, "mydata");
            } else {
              localStorage.setItem("cartNotLoggedIn", ids);

              navigate("/");
              // dispatch(alertActions.error(t("Please login to your account")));
              // navigate("/Login");
            }
          } else {
            dispatch(alertActions.error(res?.data?.status?.message));
            setRemoveRooms(false);
            // window.location.reload();
            setLoader("isfull");
          }
        })
        .catch((err) => console.log(err));
    } else {
      setChildAgeSelected(true);
    }
    // }xx
  };

  const editDetails = (roomsss, index, room) => {
    setUpdateClicked(true);
    setEditIndex(index);
    // console.log(roomsss, index, room, "differenceDate", differenceDate);

    console.log(
      "hey look here",
      roomsss,
      index,
      roomsss[index * differenceDate].infantsAbove8.length
    );
    console.log(room, "afhuadhjfkdsajfiojadsijf", roomsss, index);
    setAdultLengthDisplay(room.actualAdultCount);
    setChildrenLengthDisplay(room.infants.length);
    setTempRoomCount((prev) => prev + 1);
    setTempAdultCount(
      (prev) => prev + roomsss[index * differenceDate].actualAdultCount
    );
    setSelectAdultEdit(roomsss[index * differenceDate].actualAdultCount);
    setSelectedChildrenCount(
      (prev) => prev + roomsss[index * differenceDate].infants.length
    );
    setChildrenCount(roomsss[index * differenceDate].infants.length);
    setSelectChildrenEdit(roomsss[index * differenceDate].infants.length);

    setRemoveRooms(true);
    setAdultcount(room?.actualAdultCount);
    setChildrenCount(room?.infants?.length);
    console.log(childArrayAge, "childArrayAge", room?.infants);
    // if (childArrayAge === JSON.stringify(room?.infants)) {
    //   setChildrenAges(room?.infants);
    // } else {
    //   setChildrenAges([]);
    // }
    if (
      room?.infants?.every((age) => childArrayAge?.includes(age)) // Check if all room.infants exist in childArrayAge
    ) {
      // if (
      //   room?.infants.length === childArrayAge.length &&
      //   room?.infants.every((age, index) => age === childArrayAge[index])
      // ) {
      setChildrenAges(room?.infants); // Assign if both are exactly the same
      // } else {
      //   setChildrenAges([]); // Assign empty array if order differs
      // }
    } else {
      setChildrenAges([]); // Assign empty array if elements do not match
    }

    // setChildrenAges(room?.infants);

    const adultsArray = roomsss
      ?.filter((room) => room.roomTypeId === room.roomTypeId)
      ?.map((filteredRoom) => filteredRoom.actualAdultCount);

    const filteredArray = adultsArray?.filter(
      (_, index) => index % differenceDate === 0
    );

    const childrenArray = roomsss
      ?.filter((room) => room.roomTypeId === room.roomTypeId)
      ?.map((filteredRoom) => filteredRoom?.infants?.length);

    const filteredArray1 = childrenArray?.filter(
      (_, index) => index % differenceDate === 0
    );

    const childrenArrayAbove = roomsss
      ?.filter((room) => room.roomTypeId === room.roomTypeId)
      ?.map((filteredRoom) => filteredRoom?.infantsAbove8?.length);

    const filteredArray2 = childrenArrayAbove?.filter(
      (_, index) => index % differenceDate === 0
    );
    console.log("adultsArray", adultsArray);
    console.log("filteredArray", filteredArray);
    console.log("filteredArray1", filteredArray1);
    console.log("filteredArray2", filteredArray2);
    console.log("childrenArray", childrenArray);
    console.log("childrenArrayAbove", childrenArrayAbove);
    console.log("setChildrenAges", childrenAges);
    setExtractedData(
      cartData?.rooms?.map(
        ({
          adults,
          bookingId,
          roomTypeId,
          room_type,
          infantsUnder8,
          infantsAbove8,
          infants,
          actualAdultCount,
          no_of_occupancy,
          no_of_infants,
        }) => ({
          adults,
          bookingId,
          roomTypeId,
          room_type,
          infantsUnder8,
          infantsAbove8,
          infants,
          actualAdultCount,

          no_of_occupancy,
          no_of_infants,
        })
      )
    );
  };

  const handleChildAgeChange = (index, event) => {
    setChildAgeSelected(false);
    const newAges = [...childrenAges];
    newAges[index] = parseInt(event.target.value, 10);
    setChildrenAges(newAges);

    console.log("Updated Children Ages:", newAges);
  };

  const deleteRoom = (room, index) => {
    console.log(room, index, "bookingIds");

    const startIndex = index * differenceDate;
    const endIndex = startIndex + differenceDate;

    const bookingIds = room
      .slice(startIndex, endIndex)
      .map((item) => item.bookingId);

    console.log(bookingIds, "bookingIds");
    MyAccountService.deleteCartBooking(bookingIds, cartId)
      .then((res) => {
        if (res?.data?.status?.code === 0) {
          setTempRoomCount((prev) => prev + 1);
          setTempAdultCount(
            tempAdultCount + room[index * differenceDate].actualAdultCount
          );
          setSelectedChildrenCount(
            (prev) => prev + room[index * differenceDate].infants.length
          );
          // setPageCount(res?.data?.data?.totalPages);
          setRemoveRooms(false);
          // getBookingHistory();
          dispatch(alertActions.success(res?.data?.status?.message));
          if (user_id) {
            MyAccountService.getCartItems(user_id, 1)
              .then((res) => {
                if (res?.data?.status?.code === 0) {
                  setCartData(res?.data?.data[0]);
                  setCartId(res?.data?.data[0]?.cartId);
                  console.log(res?.data?.data[0]);
                  setDifferenceDate(
                    calculateDifference(
                      res?.data?.data[0]?.arrival_date,
                      res?.data?.data[0]?.departure_date
                    )
                  );
                  setRoomsDatassss(res?.data?.data[0]?.rooms);
                  // setPageCount(res?.data?.data?.totalPages);
                  // // console.log(res?.data?.data?.docs, "jdkshgsdfhg");
                  // const totalGST = res?.data?.data?.reduce((sum, item) => {
                  //   return sum + (item.gst || 0);
                  // }, 0);
                  // const totalRoomCharge = res?.data?.data?.reduce((sum, item) => {
                  //   return sum + (item.roomCharge || 0);
                  // }, 0);
                  // setTotalingGst(totalGST);
                  // setTotalingRoomCharge(totalRoomCharge);
                  // setCartData(res?.data);
                  setLoader("isfull");
                }
              })
              .catch((error) => {
                setLoader("isfull");
                console.log("Errorreg", error);
                dispatch(alertActions.error(error));
              });
          }
          // setLoader("isfull");
          // window.location.reload();
        } else {
          setLoader("isfull");
          setRemoveRooms(false);
          dispatch(alertActions.error(res?.data?.status?.message));
        }
      })
      .catch((error) => {
        setLoader("isfull");
        setRemoveRooms(false);
        console.log("Errorreg", error);
      });
  };

  const calculateDifference = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const diffTime = end - start;
    return diffTime / (1000 * 60 * 60 * 24);
  };

  useEffect(() => {
    if (roomsDatassss?.length) {
      console.log("Data exists in cart");
      const totalAdults = roomsDatassss.reduce(
        (sum, item) => sum + item.actualAdultCount / differenceDate,
        0
      );
      const totalChildren = roomsDatassss.reduce(
        (sum, item) => sum + item.infants.length / differenceDate,
        0
      );
      setTempRoomCount(
        Number(RoomCountLoc) - roomsDatassss?.length / differenceDate
      );
      console.log(AdultCountLoc, totalAdults, "kjsdahfkuhfdguhfsdgh");
      setTempAdultCount(
        Number(AdultCountLoc) - Number(Math.round(totalAdults))
      );
      setSelectedChildrenCount(Number(ChildrenCountLoc) - (totalChildren || 0));
    } else {
      console.log("Cart is empty");
      setTempRoomCount(Number(RoomCountLoc));
      setTempAdultCount(Number(AdultCountLoc));
      setSelectedChildrenCount(0);
    }
    // if(refreshClickked == false){
    //   setTempRoomCount(0);
    //   setTempAdultCount(0);
    // }else
    // {

    //   setTempRoomCount(Number(RoomCountLoc));
    // setTempAdultCount(Number(AdultCountLoc));
    // }
  }, [RoomCountLoc, AdultCountLoc, ChildrenCountLoc]);

  return {
    selectRoom,
    addRoom,
    updateRoom,
    AddRoomCart,
    closeModal,
    handleChangeAdult,
    handleChange,
    proceedBtn,
    deleteRoom,
    handleChildAgeChange,
    editDetails,
    user_id,
    roomList,
    notAvailable,
    loader,
    initialRoom,
    selectedRoomCount,
    selectedAdultCount,
    selectedChildrenCount,
    singleRoomDetail,
    childrenCount,
    adultcount,
    removeRooms,
    roomsDatassss,
    addedPersons,
    differenceDate,
    childAgeSelected,
    childrenAges,
    modalRenderTrigger,
    updateClicked,
    tempAdultCount,
    tempRoomCount,
    startTime,
    endTime,
    cartData,
    selectAdultEdit,
    selectChildrenEdit,
    adultLengthDisplay,
    childrenLengthDisplay,
    childArrayAge,
    nutralCheckIn,
    nutralCheckOut,
    AdultCountLoc,
    RoomCountLoc,
    closeModalEdit,
  };
};
export default useHome;
